document.addEventListener('alpine:init', () => {
  Alpine.data('toc', () => ({
    innerBlocks: null,
    headings: [],
    spacers: [],
    active: {},

    init() {
      this.innerBlocks = this.$root.querySelector('[x-ref="innerBlocks"]');
      this.headings = this.innerBlocks.querySelectorAll('h1, h2, h3, h4, h5, h6');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const spacer = entry.target;
            this.active[spacer.dataset.id] = entry.isIntersecting;
            this.updateLine();
          });
        },
        { rootMargin: '-80px 0px -80px 0px' }
      );

      this.headings.forEach((heading) => {
        const spacer = document.createElement('div');
        spacer.classList.add('toc-spacer');
        spacer.dataset.id = heading.id;
        this.spacers.push(spacer);
        heading.classList.add('relative');
        heading.append(spacer);
      });

      this.updateSpacers();

      this.spacers.forEach((spacer) => {
        this.active[spacer.dataset.id] = false;
        observer.observe(spacer);
      });

      window.addEventListener('load', () => this.update());
      window.addEventListener('resize', () => this.update());

      this.$root.querySelectorAll('img').forEach((img) => {
        img.addEventListener('load', () => this.update());

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const classList = mutation.target.classList;
              if (classList.contains('lazyloaded')) {
                this.update();
              }
            }
          });
        });

        if (img.classList.contains('lazyload')) {
          observer.observe(img, { attributes: true, attributeFilter: ['class'] });
        }
      });

      document.body.style.overflow = 'initial';
    },

    updateSpacers() {
      this.headings.forEach((heading, i) => {
        const next = this.headings[i + 1];
        const currentOffsetTop = this.calcHeadingOffsetTop(heading);
        const nextOffsetTop = next ? this.calcHeadingOffsetTop(next) : this.innerBlocks.scrollHeight;
        this.spacers[i].style.height = `${nextOffsetTop - currentOffsetTop - 10}px`;
      });
    },

    calcHeadingOffsetTop(heading) {
      let el = heading;
      let offset = heading.offsetTop;
      while (el.offsetParent && el.offsetParent !== this.innerBlocks) {
        el = el.offsetParent;
        offset += el.offsetTop;
      }
      return offset;
    },

    updateLine() {
      const ids = Object.entries(this.active)
        .filter(([_, isActive]) => isActive)
        .map(([id]) => id);

      if (ids.length) {
        const top = this.$refs.nav.querySelector(`[data-id="${ids[0]}"]`).offsetTop;
        const last = this.$refs.nav.querySelector(`[data-id="${ids[ids.length - 1]}"]`);
        const bottom = last.offsetTop + last.offsetHeight;
        this.$refs.line.style.transform = `translate3d(0, ${top}px, 0)`;
        this.$refs.line.style.height = `${bottom - top}px`;
      } else {
        this.$refs.line.style.height = '0';
      }
    },

    update() {
      this.updateSpacers();
      this.updateLine();
    },
  }));
});